import type { RouteObject } from "react-router-dom";
import { Navigate, useParams } from "react-router-dom";
import type { ReactNode } from "react";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import Pillar from "@/pages/pillar/page";
import { SUPPORTED_LANGS } from "@/hooks/useLanguage";

function LangGate({ children }: { children: ReactNode }) {
  const { lang } = useParams();
  if (lang && !SUPPORTED_LANGS.includes(lang as (typeof SUPPORTED_LANGS)[number])) {
    return <Navigate to="/en" replace />;
  }
  return <>{children}</>;
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/en" replace />,
  },
  {
    path: "/:lang",
    element: (
      <LangGate>
        <Home />
      </LangGate>
    ),
  },
  {
    path: "/:lang/basetao-spreadsheet",
    element: (
      <LangGate>
        <Article />
      </LangGate>
    ),
  },
  {
    path: "/:lang/article/:slug",
    element: (
      <LangGate>
        <Pillar />
      </LangGate>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;